import { matchPath } from 'react-router-dom';

const isUrlMatchesRoutes = (routes, url) => routes.some((route) => matchPath(route, url));

export default isUrlMatchesRoutes;
